import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

interface TabPanelProps {
  children?: React.ReactNode;
  index?: number;
  value?: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`faqs-content-${index}`}
      aria-labelledby={`faqs-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ px: 1, pt: 2 }}>{children}</Box>}
    </div>
  );
}

// function a11yProps(index: number) {
//   return {
//     id: `faqs-${index}`,
//     'aria-controls': `faqs-${index}`,
//   };
// }

const FAQs = () => {
  const [value, setValue] = useState(6);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <AppLayout
      meta={
        <Meta
          title="Form 990-N FAQs: E-Filing for Small Nonprofits"
          description="Optimize your IRS Form 990-N e-filing with TaxZerone's Knowledge Base and FAQs."
          keywords=""
          canonical="faqs/form-990-n/"
        />
      }
    >
      <Container maxWidth="md">
        <Stack
          direction={{ xs: 'column', md: 'column' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0, textAlign: 'center' }, py: 3 }}
        >
          <Box
            component="div"
            sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                fontWeight: 600,
                color: '#374151',
                mb: 3,
              }}
            >
              <span className="highlight-container">
                <span className="highlight">FAQs - Form 990-N</span>
              </span>{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
              }}
              id="general"
            >
              Here are some common questions you may have about Form 990-N
            </Typography>
          </Box>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',

          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5, px: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="flex-start"
            spacing={2}
          >
            <Hidden smDown>
              <Box
                sx={{
                  maxWidth: 180,
                  position: 'sticky',
                  top: 90,
                  border: '1px solid #ccc',
                  mt: '24px !important',
                  borderRadius: 2,
                  boxShadow: '0 0 10px rgba(0,0,0,.10)',
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  orientation="vertical"
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    py: 1,
                  }}
                  className="faq-container"
                >
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          General
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      //  color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 2290
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{
                              width: 12,
                              height: 12,
                              marginRight: 4,
                              marginTop: 3,
                            }}
                          />
                          Form 2290 Amendments
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8849
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-EZ
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-ez/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-N
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 941
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-941/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 7004
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 4868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 15397
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
              </Box>
            </Hidden>
            <Hidden smUp>
              <Box
                sx={{
                  position: 'sticky',
                  top: 62,
                  backgroundColor: '#213e99',
                  zIndex: 1,
                  width: '100%',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    '& .MuiSvgIcon-root': { fill: '#fff' },
                    maxWidth: 380,
                    mt: '2px',
                  }}
                  className="faq-container"
                >
                  <Tab
                    label="General"
                    // {...a11yProps(0)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label="Form 2290"
                    //  {...a11yProps(1)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label="Form 2290 Amendments"
                    //  {...a11yProps(2)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label="Form 8849"
                    //  {...a11yProps(3)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label="Form 990"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label="Form 990-N"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label="Form 7004"
                    //  {...a11yProps(5)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label="Form 4868"
                    //  {...a11yProps(6)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label="Form 8868"
                    //  {...a11yProps(7)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label="Form 15397"
                    //  {...a11yProps(8)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
                <Box sx={{ borderBottom: 0, borderColor: 'divider' }} />
              </Box>{' '}
            </Hidden>
            <Box
              sx={{
                width: '100%',
                pt: { sm: '8px !important' },
                px: { xs: 2, sm: 0 },
              }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <TabPanel>
                {/* <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: 18, sm: 20, md: 24, lg: 30 },
                    fontWeight: 600,
                  }}
                >
                  Form 990-N
                </Typography> */}
                <Grid container spacing={0} rowSpacing={2} m={0} mt={0}>
                  {/* <Grid size={12} sx={{ pt: '0 !important' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is Form 990-N (e-Postcard)?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <Link
                            href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}?ref=faqs`}
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            Form 990-N (e-Postcard)
                          </Link>{' '}
                          is a simplified electronic filing option for small
                          tax-exempt organizations with gross receipts of up to
                          <span style={{ fontWeight: 600 }}> $50,000</span>{' '}
                          annually. It allows them to fulfill their annual
                          reporting requirements with the IRS easily. This form
                          requires basic information and must be filed annually
                          to maintain their{' '}
                          <span style={{ fontWeight: 600 }}>
                            tax-exempt status
                          </span>
                          .
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid> */}
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What are Form 990-N (e-Postcard) requirements?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              The organization's gross receipts must be below or
                              equal to $50,000 annually to be eligible for{' '}
                              <Link
                                href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}?ref=faq`}
                                sx={{ color: '#0202ff' }}
                              >
                                {' '}
                                Form 990-N
                              </Link>{' '}
                              filing.
                            </li>
                            <li>
                              As the name suggests, Form 990-N is an e-Postcard,
                              and it must be filed electronically through the
                              IRS website or an authorized tax software
                              provider. Paper filings are not accepted.
                            </li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Box
                      component="div"
                      sx={{ mb: 1, p: 2, borderRadius: 2 }}
                      className="gradient-bg"
                    >
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        spacing={2}
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Box sx={{ width: '100%' }}>
                          <Typography
                            variant="h3"
                            sx={{
                              fontSize: '18px !important',
                              fontWeight: 600,
                              mb: 1,
                              lineHeight: 1.5,
                            }}
                          >
                            E-File Form 990-N for the tax year easily with
                            TaxZerone
                          </Typography>
                          <Typography variant="body2">
                            We support tax years 2025, 2024, and 2023.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            width: '100%',
                            maxWidth: 200,
                            textAlign: 'center',
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              textTransform: 'none',
                              boxShadow: 'none',
                              borderRadius: 2,
                              backgroundColor: '#fff',
                              color: '#333',
                              '&:hover, &:focus, &:active': { color: '#fff' },
                            }}
                            size="large"
                            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=faqs`}
                          >
                            E-file Now
                          </Button>
                        </Box>
                      </Stack>
                    </Box>
                  </Grid>
                  {/* <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        How to file Form 990-N (e-Postcard)?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          Form 990-N (e-Postcard) can only be filed
                          electronically. With TaxZerone, you can complete the
                          filing in 3 simple steps:
                          <ol>
                            <li>
                              Enter your EIN to retrieve your
                              organization&apos;s information stored in the IRS
                              database.
                            </li>
                            <li>
                              Review whether the information is correct and make
                              changes if necessary.
                            </li>
                            <li>
                              Choose the tax year and transmit your Form 990-N
                              (e-Postcard) to the IRS.
                            </li>
                          </ol>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid> */}
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        When are gross receipts normally considered $50,000 or
                        less for exempt organizations?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          According to the IRS, gross receipts are considered to
                          be normally $50,000 or less if the organization meets
                          the following criteria:
                          <ul>
                            <li>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                In existence for 1 year or less:
                              </span>{' '}
                              The organization received, or had pledges for,
                              $75,000 or less during its first tax year.
                            </li>
                            <li>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                In existence between 1 and 3 years:
                              </span>{' '}
                              The organization averaged $60,000 or less in gross
                              receipts during each of its first two tax years.
                            </li>
                            <li>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                In existence for 3 years or more:
                              </span>{' '}
                              The organization averaged $50,000 or less in gross
                              receipts over the immediately preceding three tax
                              years, including the year for which the
                              calculation is being made.
                            </li>
                          </ul>
                          For more details, refer to the{' '}
                          <Link
                            href="https://www.irs.gov/charities-non-profits/annual-electronic-filing-requirement-for-small-exempt-organizations-form-990-n-e-postcard?"
                            target="_blank"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            IRS guidelines
                          </Link>{' '}
                          on Form 990-N.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Who needs to file Form 990-N (e-Postcard)?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          Nonprofit organizations that have{' '}
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            gross receipts of $50,000
                          </span>{' '}
                          or less can file Form 990-N (e-Postcard) with the IRS.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Are there any penalties for missing the Form 990-N
                        deadline?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          There are{' '}
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            no monetary penalties
                          </span>{' '}
                          for filing Form 990-N (e-postcard) late, according to
                          IRS guidelines. However, if you don't file the form
                          for{' '}
                          <span style={{ fontWeight: 600 }}>
                            three consecutive years
                          </span>
                          , the IRS will revoke your organization's tax-exempt
                          status.
                          <Alert
                            severity="warning"
                            icon={false}
                            sx={{
                              mt: 2,
                              borderLeft: '3px solid rgb(102, 60, 0)',
                            }}
                          >
                            <b>Note:</b> You will receive a reminder notice from
                            the IRS when you miss the deadline.
                          </Alert>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        When is the deadline for filing Form 990-N ?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          IRS Form 990-N must be filed by the 15th day of the
                          5th month after the close of your organization's tax
                          year.
                          <Alert
                            severity="warning"
                            icon={false}
                            sx={{
                              mt: 2,
                              borderLeft: '3px solid rgb(102, 60, 0)',
                            }}
                          >
                            <b>Note:</b> e-Postcard cannot be e-filed until
                            after your tax year ends.
                          </Alert>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What information is required to file IRS Form 990-N ?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box itemProp="text">
                          <Typography
                            variant="body1"
                            component="div"
                            sx={{ mb: 2 }}
                          >
                            The only information required to file Form 990-N is
                            your EIN. Once entered, your organization's details
                            will be automatically fetched from the IRS database.
                            For a detailed guide, refer to our{' '}
                            <Link
                              href="/resources/tax-exempt/form-990-n-instructions/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 990-N Instructions
                            </Link>{' '}
                            page.
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Can I file the previous year's Form 990-N (e-Postcard)
                        return?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          Yes, you can file the previous year’s IRS Form 990-N
                          (e-Postcard) return with TaxZerone. TaxZerone supports
                          e-filing for multiple tax years, helping you
                          efficiently manage both past and current returns.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Can I file Form 990 or 990-EZ instead of Form 990-N
                        (e-Postcard)?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          Yes. You can file{' '}
                          <Link
                            href="/tax-exempt/e-file-irs-form-990/"
                            sx={{ color: '#0202ff' }}
                          >
                            Form 990
                          </Link>{' '}
                          or{' '}
                          <Link
                            href="/tax-exempt/e-file-irs-form-990-ez/"
                            sx={{ color: '#0202ff' }}
                          >
                            990-EZ
                          </Link>{' '}
                          instead of{' '}
                          <Link
                            href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}?ref=faqs`}
                            sx={{ color: '#0202ff' }}
                          >
                            Form 990-N (e-Postcard)
                          </Link>
                          . However, you will need to complete the form and
                          applicable schedules manually. On the other hand, if
                          your organization's gross receipts are less than
                          $50,000, we recommend that you file 990N to save time.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Which organizations cannot file e-Postcard?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          Below are the organizations that cannot file{' '}
                          <Link
                            href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}?ref=faqs`}
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            e-Postcard
                          </Link>
                          :
                          <ul>
                            <li>
                              Organizations with gross receipts over $50,000
                            </li>
                            <li>Private foundations </li>
                            <li>Section 509(a)(3) supporting organizations </li>
                            <li>Section 527 (political) organizations</li>
                            <li>
                              Section 501(c)(1) – U.S. government
                              instrumentalities
                            </li>
                            <li>
                              Section 501(c)(20) – Group legal services plans
                            </li>
                            <li>
                              Section 501(c)(23) – Pre-1880 Armed Forces
                              organizations
                            </li>
                            <li>Section 501(c)(24) –ERISA sec. 4049 trusts </li>
                            <li>
                              Section 501(d) – Religious and apostolic
                              organizations
                            </li>
                            <li id="form7004">
                              Section 529 – Qualified tuition programs
                            </li>
                            <li>Section 4947(a)(2) – Split-interest trusts </li>
                            <li>
                              Section 4947(a)(1) – Charitable trusts treated as
                              private foundations
                            </li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Ready to simplify your complex tax filing process?
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
          }}
        >
          Choose TaxZerone and file IRS tax forms online in easy steps.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=faqs`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default FAQs;
